import { render, staticRenderFns } from "./LogTransferWallet.vue?vue&type=template&id=01a8f912&"
import script from "./LogTransferWallet.vue?vue&type=script&lang=js&"
export * from "./LogTransferWallet.vue?vue&type=script&lang=js&"
import style0 from "./LogTransferWallet.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports